import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import EditAcademicSession from '../../../../components/partials/academicSessions/EditAcademicSession';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CreateNewTerm from '../../../../components/partials/academicSessions/CreateNewTerm';
import { clearCreatedTerm, fetchTerms } from '../../../../store/actions/termsActions';
import Loader from '../../../../components/elements/Loader';
import { ERROR } from '../../../../store/types';
import { authHeader } from '../../../../utils';
import axios from 'axios';
import moment from 'moment';
import PencilSquareIcon from '../../../../components/elements/icons/PencilSquareIcon';
import { fetchAdmissions } from '../../../../store/actions/admissionsActions';
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon';
import EmptyState from '../../../../components/elements/EmptyState';
import CloseIcon from '../../../../components/elements/icons/CloseIcon';
import NewAdmission from '../../../../components/partials/admissions/NewAdmission';
import { fetchAcademicSessions } from '../../../../store/actions/academicSessionsActions';
import EditTerm from '../../../../components/partials/academicSessions/EditTerm';

const AcademicSessionDetails = () => {
    const dispatch = useDispatch()
    const termsSelector = useSelector(state => state.terms)
    const openingsSelector = useSelector((state => state.admissions))
    
    const [sessionDetails, setSessionDetails] = useState(null)
    const [reload, setReload] = useState(0)
    const [loading, setLoading] = useState(true)
    const { sessionId } = useParams()

    useEffect(() => {
        dispatch(fetchAcademicSessions('', 0, 0))
        dispatch(fetchTerms(`session=${sessionId}`, 0, 0))
        dispatch(fetchAdmissions(`academicSession=${sessionId}`, 0, 0))
        const getSessionDetails = async () => {
            try {
                const headers = authHeader()
                setLoading(true)
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/academic-sessions/${sessionId}`, { headers })            

                setSessionDetails(response.data.data)
                setLoading(false)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }

        getSessionDetails()

        if(termsSelector.createdTerm && termsSelector.createdTerm !== null) {
            setCreatingTerm(false)
            dispatch(clearCreatedTerm())
        }

        return () => {
            
        }
    }, [dispatch, reload, sessionId, termsSelector.createdTerm])
    
    const [editingSession, setEditingSession] = useState(false);

    const [creatingTerm, setCreatingTerm] = useState(false)

    const [creatingAdmission, setCreatingAdmission] = useState(false)

    const [updatingTerm, setUpdatingTerm] = useState(false)
    const [activeTerm, setActiveTerm] = useState(null)

    const openTermUpdate = (term) => {
        setActiveTerm(term)
        setTimeout(() => {
            setUpdatingTerm(true)
        }, 200);
    }

    const closeTermUpdate = () => {
        setUpdatingTerm(false)
        setTimeout(() => {
            setActiveTerm(null)
        }, 200);
    }

    return (
        <>
            <AdministrationLayout pageTitle="Academic Session Details">
                {loading ?
                    <Loader  /> 
                    :
                    <div className='w-full'>
                        <div className='mb-2'>
                            <div className="w-full mx-auto">
                                <div className='w-full flex items-center justify-between'>
                                    <div className='w-2/3'>
                                        <h4 className='font-medium text-lg mb-1 text-gray-800'>{sessionDetails.name}</h4>
                                        {/* <div className=''>
                                            <p className='text-gray-500 mt-1 text-sm'>
                                                Below is a list of payments to Vaatia College
                                            </p>
                                        </div> */}
                                    </div>
                                    <div className='flex flex-row-reverse gap-x-[10px]'>
                                        
                                        <button onClick={()=>{setEditingSession(true)}} className='rounded px-4 py-3 mt-4 text-sm text-vcm-purple bg-vcm-light-purple transition duration-200 w-[200px] border border-vcm-purple hover:bg-gray-200 flex items-center justify-center gap-x-2'>
                                            <PencilSquareIcon className={`w-5 h-5`} />
                                            Edit Session
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className=''>
                            <div className=''>
                                <label className='text-xs uppercase tracking-[0.2em] block mb-[10px]'>Session Dates</label>
                                <p className='text-sm text-gray-500'>From <span className='font-space-grotesk font-[550] text-md text-gray-800'>{moment(sessionDetails.startDate).format('dddd, MMMM Do YYYY')}</span> through <span className='font-space-grotesk font-[550] text-md text-gray-800'>{moment(sessionDetails.endDate).format('dddd, MMMM Do YYYY')}</span></p>
                            </div>

                            <div className='flex items-start justify-between mt-[40px]'>
                                <div>
                                    <h4 className='font-medium text-md mb-1 text-gray-600'>Admission openings for {sessionDetails.name}</h4>
                                    <p className='text-sm text-gray-500'>All admission openings for this academic session.</p>
                                </div>
                                <button onClick={()=>{setCreatingAdmission(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 w-[200px] border border-vcm-purple hover:bg-purple-200 hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                    Create a new Opening
                                </button>
                            </div>

                            {openingsSelector?.admissions?.admissions?.length > 0 ? <div className='mt-[20px]'>
                                {/* <label className='text-xs uppercase tracking-[0.2em] block mb-[10px]'>Session Admission openings</label> */}
                                
                                <div className='grid grid-cols-3 gap-[10px]'>
                                    {openingsSelector?.admissions?.admissions?.map((opening, openingIndex)=>(<div key={openingIndex} className='bg-gray-50 rounded-[8px] p-[25px]'>
                                        <div className='flex items-center gap-x-[5px] mb-[5px]'>
                                            <h3 className='font-space-grotesk font-[550] text-md text-gray-800'>
                                                {opening.title}
                                            </h3>
                                            <span className={`inline-block text-xs px-2 py-1 rounded font-outfit capitalize
                                                ${opening.type === 'SUPPLEMENTARY' && 'bg-vcm-light-purple text-vcm-purple bg-opacity-20'}
                                                ${opening.type === 'MAIN' && 'bg-blue-600 text-blue-800 bg-opacity-10'}
                                                `}>{opening.type.toLowerCase()}
                                            </span>
                                        </div>
                                        <p className='text-sm text-gray-500'>Open from <span className='text-gray-800'>{moment(opening.endDate).format('dddd, MMMM Do YYYY')}</span> through <span className='text-gray-800'>{moment(opening.endDate).format('dddd, MMMM Do YYYY')}</span></p>
                                        <p className='text-sm text-gray-600 mt-[10px]'>{opening.requiredDocuments?.length || 0} documents required</p>
                                        <p className='text-[15px] text-gray-600 mt-[10px]'>{<span>₦{(opening?.fee?.amount/100).toLocaleString()}</span>} application fee</p>
                                        <div className='flex flex-row-reverse'>
                                            <Link to={`/admin/administration/admissions/${opening._id}`}  className='text-sm flex flex-row items-center font-space-grotesk mt-[20px] gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>Opening Details <ArrowIcon className={`w-4 h-4`} /></Link> 
                                        </div>
                                    </div>))}
                                </div>

                            </div> 
                            :
                            
                            <EmptyState 
                                emptyStateTitle={`No Openings Found`}
                                emptyStateText={`No admission openings created for this academic session yet. Click on "Create a new Opening" above if you need to create one.`}
                            />
                            }

                            <div className='mt-[50px]'>
                                <div className='flex items-start justify-between'>
                                    <div>
                                        <h4 className='font-medium text-md mb-1 text-gray-600'>Terms for {sessionDetails.name}</h4>
                                        <p className='text-sm text-gray-500'>All school terms for this academic session.</p>
                                    </div>
                                    <button onClick={()=>{setCreatingTerm(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border w-[200px] border-vcm-purple hover:bg-purple-200 hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                        Create a new Term
                                    </button>
                                </div>
                                {termsSelector?.terms?.terms?.length > 0 ? <div className='mt-[40px]'>
                                    {termsSelector.terms.terms.map((term, termIndex) => (
                                        <div key={termIndex} className='rounded-[8px] w-full p-[20px] flex items-start justify-between gap-x-[20px] bg-white border border-gray-200 mb-[10px]'>
                                            <div className='w-4/12'>
                                                <div className='w-full'>
                                                    <div className='flex items-center gap-x-[5px]'>
                                                        <p className='text-sm mb-[5px]'>{term.name}</p>
                                                        {term.currentlyActive && <span className={`inline-block text-xs px-2 py-1 rounded font-outfit capitalize bg-vcm-light-purple text-vcm-purple bg-opacity-50`}> Current Term</span>}
                                                    </div>
                                                    {term.description && term.description !=='' && <p className='text-sm mt-[5px] text-gray-500 mb-[5px]'>{term.description}</p>}
                                                </div>
                                            </div>

                                            <div className='w-3/12'>
                                                <div className='w-full'>
                                                    <p className='text-sm text-gray-500'>Open Date: <span className='text-gray-800'>{moment(term.startDate).format('dddd, MMMM Do YYYY')}</span> </p>
                                                    <p className='text-sm text-gray-500 mt-[5px]'>Close Date: <span className='text-gray-800'>{moment(term.endDate).format('dddd, MMMM Do YYYY')}</span></p>
                                                </div>
                                            </div>
                                            
                                            <div className='w-2/12'>
                                                <div className='w-full'>
                                                    <label className='text-sm block text-gray-500'>Students Checked in this term</label>
                                                    <p className='text-sm mb-[5px]'>{term.checkedInStudents || 0}</p>
                                                </div>
                                            </div>
                                            
                                            <div className='w-3/12 pt-2'>
                                                <div className='w-full flex flex-row-reverse gap-x-[5px]'>
                                                    {term.currentlyActive && <button className='py-[6px] px-[10px] rounded-full text-xs font-space-grotesk bg-red-50 border border-red-500 font-semibold flex text-red-800 items-center justify-center gap-x-[5px]'>
                                                        <CloseIcon className={`w-4 h-4`} />
                                                        Close Term
                                                    </button>}
                                                    <button onClick={()=>{openTermUpdate(term)}} className='py-[6px] px-[10px] rounded-full text-xs font-space-grotesk font-550 bg-gray-50 border border-dashed border-gray-400 flex items-center justify-center gap-x-[5px]'>
                                                        <PencilSquareIcon className={`w-4 h-4`} />
                                                        Edit Term
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                                
                                :

                                <div className='mt-[100px]'>
                                    <EmptyState
                                        emptyStateTitle={`No terms created for this academic session yet.`}
                                        emptyStateText={`No terms created yet. Please click on "Create New Term" above to create one within this session.`} />
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </AdministrationLayout>

            <ModalDialog
                shown={editingSession} 
                closeFunction={()=>{setEditingSession(false)}} 
                actionFunction={()=>{}} 
                dialogTitle='Update Academic Session'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <EditAcademicSession 
                    reload={()=>setReload(reload+1)}
                    session={sessionDetails}
                    closeFunction={()=>{setEditingSession(false)}} 
                />

            </ModalDialog>

            <ModalDialog
                shown={creatingTerm} 
                closeFunction={()=>{setCreatingTerm(false)}} 
                actionFunction={()=>{}} 
                dialogTitle='Create New Term for this Academic Session'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <CreateNewTerm close={()=>{setCreatingTerm(false)}} academicSession={sessionDetails} />

            </ModalDialog>

            {activeTerm && <ModalDialog
                shown={updatingTerm} 
                closeFunction={()=>{closeTermUpdate()}} 
                actionFunction={()=>{}} 
                dialogTitle='Update Term'
                maxWidthClass='max-w-md'
                hideActions={true}
            >
                <EditTerm close={()=>{closeTermUpdate()}} term={activeTerm} />

            </ModalDialog>}

            <ModalDialog
                shown={creatingAdmission} 
                closeFunction={()=>{setCreatingAdmission(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={`Create a new admission`}
                dialogTitle={`Create a new admission or opening for the academic session ${sessionDetails?.name}`}
                maxWidthClass='max-w-6xl'
                hideActions={true}
            >
                <NewAdmission
                    reload={()=>setReload(reload+1)}
                    closeFunction={()=>{setCreatingAdmission(false)}} 
                    academicSession={sessionDetails}
                />
            </ModalDialog>
        </>
    )
}

export default AcademicSessionDetails